module.exports = __webpack_public_path__ + "img/ico_drag_item_black.69e6f2e5.svg";